import React from "react";
import AppActivityIndicator from "@toothfairy/shared-ui/AppActivityIndicator";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppSwitch from "@toothfairy/shared-ui/AppSwitch";
import { AppText } from "@toothfairy/shared-ui";
import { View } from "react-native";
import { useReactiveVar } from "react-reactive-var";
import { appDimensions } from "../../MainViewContainer";

const DashboardItem = ({
  isFetchInProgress,
  children,
  title,
  isToogleVisible,
  toogleLabel,
  isTicked,
  handleTick = () => {},
  isHalfWidth = true,
  additionalTitle,
  customWidth,
  dashboardTitleWrapperStyle,
  mainTitleWrapperStyle,
  additionalTitleWrapperStyle,
  ...props
}) => {
  const { width } = useReactiveVar(appDimensions);
  const { currentTheme } = AppTheme.useTheme();

  const getWidth = () => {
    if (customWidth && width > 640) return customWidth;
    if (isHalfWidth && width > 640) return "48%";
    return "100%";
  };

  const getMinWidth = () => {
    if (customWidth && width > 640) return 250;
    return 300;
  };

  return isFetchInProgress ? (
    <AppActivityIndicator
      backgroundColor={currentTheme?.theme?.softBackgroundColor}
      visible={true}
      containerStyle={{
        backgroundColor: currentTheme?.theme?.transparent,
        minHeight: 250,
      }}
    />
  ) : (
    <View
      style={{
        alignItems: "center",
        width: getWidth(),
        minWidth: getMinWidth(),
        borderRadius: 12,
        borderWidth: 1,
        borderColor: currentTheme?.theme?.border_color,
        backgroundColor: currentTheme?.theme?.cardBackground,
        overflow: "hidden",
      }}
    >
      <View
        style={[
          {
            flexDirection: "row",
            alignSelf: "flex-start",
            justifyContent: "flex-start",
            width: "100%",
          },
          dashboardTitleWrapperStyle,
        ]}
      >
        <AppText
          fontWeight="600"
          wrapperStyle={[
            {
              marginBottom: 0,
              marginTop: 0,
              alignSelf: "flex-start",
              paddingVertical: 14,
              paddingLeft: 16,
              paddingRight: 8,
            },
            mainTitleWrapperStyle,
          ]}
          style={{
            fontSize: currentTheme?.theme?.medium_font_size,
          }}
        >
          {title}
        </AppText>
        {additionalTitle && (
          <AppText
            fontWeight="600"
            wrapperStyle={[
              {
                marginBottom: 0,
                marginTop: 0,
                alignSelf: "flex-start",
                paddingVertical: 14,
                paddingLeft: 0,
              },
              additionalTitleWrapperStyle,
            ]}
            style={{
              fontSize: currentTheme?.theme?.small_font_size,
            }}
            color={currentTheme?.theme?.primary}
          >
            {additionalTitle}
          </AppText>
        )}

        {isToogleVisible && (
          <AppSwitch
            showTextInputLabel={true}
            label={toogleLabel}
            isTicked={isTicked}
            onChange={handleTick}
          />
        )}
      </View>

      {children}
    </View>
  );
};

export default DashboardItem;
